module.exports = __webpack_public_path__ + "static/media/carlous-img4.eb7613da.jpg";